/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrtoolpagedescription3Inputs */

const en_qrtoolpagedescription3 = /** @type {(inputs: Qrtoolpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a QR code with your logo for a website or for your event. QR codes for events can also be created directly in the event.`)
};

const de_qrtoolpagedescription3 = /** @type {(inputs: Qrtoolpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle einen QR-Code mit deinem Logo für eine Webseite oder für dein Event. QR-Codes für Events können auch direkt im Event erstellt werden.`)
};

/**
* | output |
* | --- |
* | "Create a QR code with your logo for a website or for your event. QR codes for events can also be created directly in the event." |
*
* @param {Qrtoolpagedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrtoolpagedescription3 = /** @type {((inputs?: Qrtoolpagedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrtoolpagedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrtoolpagedescription3(inputs)
	return de_qrtoolpagedescription3(inputs)
});
export { qrtoolpagedescription3 as "qrToolPageDescription" }